'use client'

import { Button, Column, Grid, Theme } from '@carbon/react'
import { Catalog, Help } from '@carbon/react/icons'
import type { KmerLocale } from '@kmerhosting/i18n'
import type { HomeExtraCopy } from '@/lib/home-extra-i18n'

function localizedHref(href: string, locale: KmerLocale) {
  if (locale === 'en') return href
  const hashIndex = href.indexOf('#')
  const hash = hashIndex >= 0 ? href.slice(hashIndex) : ''
  const path = hashIndex >= 0 ? href.slice(0, hashIndex) : href
  return `/${locale}${path === '/' ? '/' : path}${hash}`
}

export function HomeCtaSection({ copy, locale }: { copy: HomeExtraCopy; locale: KmerLocale }) {
  return (
    <Theme theme="g100">
      <section id="get-started" className="cta-section" aria-labelledby="cta-title">
        <Grid>
          <Column sm={4} md={6} lg={10}>
            <h2 id="cta-title">{copy.readyTitle}</h2>
            <p>{copy.readyText}</p>
            <div className="hero__actions">
              <Button href={localizedHref('/services', locale)} renderIcon={Catalog}>{copy.chooseService}</Button>
              <Button href={localizedHref('/support', locale)} kind="tertiary" renderIcon={Help}>{copy.supportOptions}</Button>
            </div>
          </Column>
        </Grid>
      </section>
    </Theme>
  )
}
